import client from "./ApiService";

class ContentPennameService {
  constructor(params) {
    this.url = "/contentpennames";
  }

  get() {
    return client.get(this.url);
  }

  filter(filter) {
    return client.get(`${this.url}${filter ? '?name_contains='+filter : ''}`);
  }
  
  slugfilter(filter) {
    return client.get(`${this.url}${filter ? '?_q='+filter : ''}`);
  }
}

export default new ContentPennameService();
